var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"description"},[(_vm.isDescriptionObject)?_c('RichText',{key:_vm.categoriesDescriptionKey,attrs:{"text":_vm.categoriesDescription}}):_c('p',[_vm._v(_vm._s(_vm.categoriesDescription))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }